import { useState } from "react";
import { BsFillPlusCircleFill } from "react-icons/bs";
import { TbNumbers } from "react-icons/tb";
import { boardService } from "../../services/board.service";
import { ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import{ROLES}from '../../cmps/../services/user.service'

export function NumberPicker({customHeight, info, field, onUpdate,userRol }) {
    const [number, setNumber] = useState(info.number || '');
    const [isShowInput, setIsShowInput] = useState(false);
    const activity = boardService.getEmptyTask();
    
    activity.action = 'number';
    activity.from = info.number || '-';
    activity.task = { valor2: info.tablaEleccion };

    function handleNumberChange({ target }) {
        let value = target.value;
    
        // Validar que el valor sea un número positivo o vacío
        if (value === '' || (Number(value) >= 0 && !value.includes('-'))) {
            setNumber(value);
        }
    }
    

    function onSave(ev) {
        if (activity.from === '-' && !number) {
            setIsShowInput(false);
            return;
        }
        activity.to = number;
        onUpdate(ev, field, number);
        
    }


     // Determina si el campo debe estar habilitado o deshabilitado
     const isEditable = () => {
        if (userRol === ROLES.ADMIN) {
            return true; // El Administrador puede editar todo
        } else if (userRol === ROLES.TECNICO) {
            return field === "ejecucion" || field === "horas_trabajo";
        } else if (userRol === ROLES.AUDITOR) {
            return false; // El Auditor no puede editar nada
        }
        return false; // Cualquier otro rol que no esté especificado no puede editar
    };

    return (
        <section className="number-picker picker" style={{ height: customHeight }}>
            <ToastContainer />
            {(!number && !isShowInput) && (
                <span onClick={() => setIsShowInput(true)} className="add-number-icons">
                    <BsFillPlusCircleFill className="plus-icon" /><TbNumbers />
                </span>
            )}
            {(number || isShowInput) && (
                <>
                    <input
                        type="number"
                        name="number"
                        value={number}
                        onChange={handleNumberChange}
                        onBlur={(ev) => onSave(ev)}
                        disabled={!isEditable()} // Llama a la función isEditable para determinar si está deshabilitado
                    />
                    
                    
                </>
            )}
        </section>
    );
}



